import React from "react";

const Copy = () => {
  return (
    <svg
      width={21}
      height={22}
      viewBox="0 0 21 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0002 21H2.00019C1.46427 21.0186 0.944666 20.8139 0.56548 20.4347C0.186295 20.0555 -0.0184319 19.5359 0.000191672 19V8.99999C-0.0184319 8.46407 0.186295 7.94447 0.56548 7.56528C0.944666 7.1861 1.46427 6.98137 2.00019 6.99999H6.00019V2.99999C5.98157 2.46407 6.1863 1.94447 6.56548 1.56528C6.94467 1.1861 7.46427 0.98137 8.00019 0.999993H18.0002C18.5361 0.98137 19.0557 1.1861 19.4349 1.56528C19.8141 1.94447 20.0188 2.46407 20.0002 2.99999V13C20.0185 13.5358 19.8137 14.0553 19.4346 14.4344C19.0555 14.8135 18.536 15.0183 18.0002 15H14.0002V19C14.0185 19.5358 13.8137 20.0553 13.4346 20.4344C13.0555 20.8135 12.536 21.0183 12.0002 21ZM2.00019 8.99999V19H12.0002V15H8.00019C7.46435 15.0183 6.94493 14.8135 6.56581 14.4344C6.18669 14.0553 5.98187 13.5358 6.00019 13V8.99999H2.00019ZM8.00019 2.99999V13H18.0002V2.99999H8.00019Z"
        fill="#141359"
      />
    </svg>
  );
};

export default Copy;
